module.exports = __webpack_public_path__ + "static/mysa-mattress-firmness-08a181e1477efe507f5c44e67ec621af.mp4";